export default __webpack_public_path__ + "static/media/popup.88038338.png";